/**
 * # Only allow one `<detail>` element to be open at a time.
 */
const AccordionOnlyOneDetail = () => {
    const details = document.querySelectorAll('.homepage-faq__details');

    details.forEach((targetDetail) => {
        targetDetail.addEventListener('click', () => {
            details.forEach((detail) => {
                if (detail !== targetDetail) {
                    detail.removeAttribute('open');
                }
            });
        });
    });
};

export default AccordionOnlyOneDetail;
